export default __webpack_public_path__ + "static/media/corruption.2355aaa2.png";